module.exports = __webpack_public_path__ + "static/media/command.4ada7185.svg";